// @flow @jsx h

import { Component, h } from 'preact'
import style from './Scrubber.css'

type Props = {
  class?: string,
  duration: number,
  time: number,
  onPositionUpdate?: (position: number) => void
}

type State = {
  left: number,
  width: number,
  isScrubbing: boolean,
  position: number | null
}

class VideoScrubber extends Component<Props, State> {
  bgElm: HTMLDivElement
  elm: HTMLDivElement
  handleElm: HTMLButtonElement
  positionTimeout: any
  state = {
    left: 0,
    width: 0,
    isScrubbing: false,
    position: null
  }

  componentDidMount () {
    if (this.props.onPositionUpdate) {
      this.elm.addEventListener('keydown', this.handleKeyDown)
      this.elm.addEventListener('mousedown', this.handleMouseDown)
      this.elm.addEventListener('touchstart', this.handleTouchStart)
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    }
  }

  componentWillUnmount () {
    if (this.props.onPositionUpdate) {
      this.elm.removeEventListener('keydown', this.handleKeyDown)
      this.elm.removeEventListener('mousedown', this.handleMouseDown)
      this.elm.removeEventListener('touchstart', this.handleTouchStart)
      window.removeEventListener('resize', this.handleResize)
    }
  }

  handleKeyDown = (evt: KeyboardEvent) => {
    const { duration, time, onPositionUpdate } = this.props

    if (onPositionUpdate) {
      let nextTime = time

      switch (evt.key) {
        case 'ArrowLeft':
          nextTime -= 1
          break
        case 'ArrowRight':
          nextTime += 1
          break
      }

      onPositionUpdate(Math.max(Math.min(nextTime / duration, 1), 0))
    }
  }

  handleMouseDown = (evt: MouseEvent) => {
    evt.preventDefault()
    this.focus()
    this.start(evt.pageX)
    this.elm.addEventListener('mousemove', this.handleMouseMove)
    window.addEventListener('mouseup', this.handleMouseUp)
  }

  handleMouseMove = (evt: MouseEvent) => {
    this.move(evt.pageX)
  }

  handleMouseUp = (evt: MouseEvent) => {
    this.focus()
    this.end()
    this.elm.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('mouseup', this.handleMouseUp)
  }

  handleResize = () => {
    const rect = this.bgElm.getBoundingClientRect()

    this.setState({
      left: Math.floor(rect.left),
      width: rect.width
    })
  }

  handleTouchStart = (evt: TouchEvent) => {
    if (evt.touches.length === 1) {
      evt.preventDefault()
      this.focus()
      this.start(evt.touches[0].clientX)
      this.elm.addEventListener('touchmove', this.handleTouchMove)
      window.addEventListener('touchend', this.handleTouchEnd)
    }
  }

  handleTouchMove = (evt: TouchEvent) => {
    if (evt.touches.length === 1) {
      this.move(evt.touches[0].clientX)
    }
  }

  handleTouchEnd = (evt: TouchEvent) => {
    this.focus()
    this.end()
    this.elm.removeEventListener('touchmove', this.handleTouchMove)
    window.removeEventListener('touchend', this.handleTouchEnd)
  }

  focus () {
    this.handleElm.focus()
  }

  start (clientX: number) {
    if (this.positionTimeout) {
      clearTimeout(this.positionTimeout)
    }

    this.setState({
      position: (clientX - this.state.left) / this.state.width,
      isScrubbing: true
    })
  }

  move (clientX: number) {
    this.setState({
      position: Math.max(
        Math.min((clientX - this.state.left) / this.state.width, 1),
        0
      )
    })
  }

  end () {
    if (this.props.onPositionUpdate && this.state.position !== null) {
      this.props.onPositionUpdate(this.state.position)
    }

    this.setState({
      isScrubbing: false
    })

    this.positionTimeout = setTimeout(() => {
      this.setState({
        position: null
      })
    }, 250)
  }

  render () {
    const { duration, time } = this.props
    const className = this.props.class
    const position =
      this.state.position !== null ? this.state.position : time / duration

    return (
      <div
        className={`${style.videoScrubber}${className ? ` ${className}` : ''}`}
        ref={elm => (this.elm = elm)}
      >
        <div
          className={style.videoScrubber__bgBar}
          ref={bgElm => (this.bgElm = bgElm)}
        />
        <div className={style.videoScrubber__bufferedBar} />
        <div
          className={style.videoScrubber__playedBar}
          style={{ width: `${position * 100}%` }}
        />
        <button
          ref={handleElm => (this.handleElm = handleElm)}
          role='slider'
          aria-valuemin='0'
          aria-valuemax={duration * 1000}
          aria-valuenow={time * 1000}
          style={{ left: `${position * 100}%` }}
        />
      </div>
    )
  }
}

export default VideoScrubber



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/Video/Scrubber.js